import React from "react";
import data from "../json/Allproducts/Editlatex1.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";
import Section3 from "../components/Allproducts/Section3";
import SEO from "../components/SEO";

const editLatexSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "EditLaTeX",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "url": "http://www.editlatex.com",
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "EditLaTeX is an advanced web-based LaTeX document editing and typesetting platform featuring a multi-pane interface with on-the-fly PDF generation, NLP text analysis, automated reference validation, and native TeX code editing.",
  "offers": {   
    "url": "http://www.editlatex.com"
  }
};

const EditLatex = () => {
  return (
    <>
    <SEO
        title="EditLaTeX | Web-Based LaTeX Editing & Typesetting Platform"
        description="Streamline scientific & academic publishing with EditLaTeX. Edit native TeX files with real-time PDF preview, MathJax rendering, automated reference validation, track changes, and NLP enhancement."
        keywords="EditLaTeX, online LaTeX editor, web-based typesetting platform, TeX file editing, real-time PDF generation, MathJax rendering, academic document proofing, LaTeX reference validation, XML output compatibility, collaborative LaTeX"
        canonical="https://www.transforma.in/products/editlatex" 
        schema={editLatexSchema}
      />
    <div className="w-full flex flex-col items-center  ruler">
      <Section1 data={data} />
      <Section3 data={data.Section5}/>
      <Section4 data={data.Section4}/>
     
    </div>
    </>
  );
};

export default EditLatex;
